import 'dayjs/locale/zh-cn'

import dayjs from 'dayjs'
import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { BsBellFill } from 'react-icons/bs'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import vanilla, { addBackToTop } from 'vanilla-back-to-top'

import { getLessonList } from '@/api/center'
import picEmpty from '@/assets/images/pic_empty.png'
import Comment from '@/components/Comment'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Modal from '@/components/Modal'
import Pagination from '@/components/Pagination'
import Title from '@/components/Title'
dayjs.locale('zh-cn')

export default function Index() {
  const [classState, setClassState] = useState(false)
  const [pic, setPic] = useState('')
  const [lessonId, setLessonId] = useState(0)
  const [total, setTotal] = useState(0)
  const [size, setSize] = useState(10)
  const [index, setIndex] = useState(1)
  const [list, setList] = useState([])
  const [course, setCourse] = useState<any[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    const toTop: any = document.querySelector('#back-to-top')
    if (!toTop) {
      addBackToTop({
        backgroundColor: '#FFF',
        cornerOffset: 20, // px
        diameter: 56, // px
        // ease: inOutSine, // any one from https://www.npmjs.com/package/ease-component will do
        id: 'back-to-top',
        innerHTML: '<svg color="#333" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path></svg>',
        onClickScrollTo: 0, // px
        scrollContainer: document.body, // or a DOM element, e.g., document.getElementById('content')
        scrollDuration: 250, // ms
        showWhenScrollTopIs: 500, // px
        // size: diameter, // alias for diameter
        textColor: '#fff',
        zIndex: 1
      })
    }
  }, [])

  const { isFetching, data } = useQuery(['getLessonList'], () =>
    getLessonList({
      userId: localStorage.userid,
      uniqueDeviceNo: localStorage.visitorId
    })
  )

  useEffect(() => {
    if (data && data.status === 0) {
      setList(data.data)
      setTotal(data.data.length)
      setIndex(1)
      setCourse(data.data.slice(0, 10))
    }
  }, [data])

  const change = (index: number) => {
    setIndex(index)
    const toTop: any = document.querySelector('#back-to-top')
    toTop && toTop.click()
    setTimeout(() => {
      setCourse(list.slice(index * 10 - 10, index * 10))
    }, 250)
  }

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="relative">
      <Title title="已上课程">
        <div className="flex justify-center items-center">
          <AiOutlineInfoCircle className="w-[20px] h-[20px] text-[#ff9800] mr-[5px]" />
          <span className="text-[#A1A1A1] text-[14px]">课程评价有效期：课程结束7天内可评价。</span>
        </div>
      </Title>
      <Card className="p-[20px] flex justify-center items-start mb-[10px]">
        <div className="flex-1">课程</div>
        <div className="w-[180px] text-center">作品</div>
        <div className="w-[180px] text-center">老师点评</div>
      </Card>

      <AnimatePresence exitBeforeEnter>
        <Loadding state={isFetching}>
          {course.length ? (
            course.map((item, i) => (
              <Card
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: i / 20 }}
                key={item.id}
                className="flex justify-center items-start p-[20px] mb-[20px]"
              >
                <div className="w-[120px] h-[120px] rounded overflow-hidden">
                  <ImgPlaceholder className="w-full h-full rounded anim_btn2 duration-300" src={item.cover} alt="" />
                </div>
                <div className="flex justify-between items-start flex-col flex-1 ml-[20px] h-[120px]">
                  <div className="text-[14px] text-[#5a5a5a]">
                    {item.overseasOpen
                      ? `${dayjs(item.datetime * 1000).format('YYYY年MM月DD日 dddd HH:mm')} -
                        ${dayjs(item.datetime * 1000 + 3600000).format('HH:mm')}`
                      : item.date
                        ? `${item.date} ${item.hour}`
                        : null}
                  </div>
                  <div className="text-[14px] text-[#5a5a5a]">类型：{item.courseType === '0' ? '试听课' : '正式课'}</div>
                  <div className="text-[14px] text-[#5a5a5a]">课程：{item.title}</div>
                  <div className="text-[14px] text-[#5a5a5a]">老师：{item.teacherName}</div>
                  <div className="text-[14px] text-[#5a5a5a]">状态：{item.lessonStatus}</div>
                </div>
                <div className="w-[180px] flex flex-col justify-center items-center h-[120px]">
                  {item.workImg ? (
                    <Fragment>
                      <div className="w-[90px] h-[90px] rounded overflow-hidden">
                        <ImgPlaceholder
                          onClick={() => setPic(item.workImg.endsWith('.m3u8') ? item.workVideoCoverUrl : item.workImg)}
                          className="w-full h-full rounded anim_btn2 duration-300"
                          src={item.workImg.endsWith('.m3u8') ? item.workVideoCoverUrl : item.workImg}
                          alt=""
                        />
                      </div>
                      <span className="text-[14px] text-[#999999] mt-[4px]">点击可放大查看</span>
                    </Fragment>
                  ) : (
                    <span className="text-[14px] text-[#999999] mt-[4px]">作品未上传</span>
                  )}
                </div>
                <div className="w-[180px] h-[120px] flex flex-col justify-center items-center">
                  <button
                    onClick={() => {
                      if (item.testReportUrl) {
                        // setLessonId(item.id)
                        // setClassState(true)
                        toast.success('请前往APP查看老师点评~')
                      } else {
                        toast('老师未点评', { icon: <BsBellFill className="text-[#ff3300]" /> })
                      }
                    }}
                    className={`${item.testReportUrl ? '' : 'opacity-[0.5]'} rounded-full px-[36px] py-[9px] text-[#ff3300] bg-[#ffeee8] border-[#ff3300] border-[1px] border-solid anim_btn2`}
                  >
                    查看老师点评
                  </button>
                </div>
              </Card>
            ))
          ) : (
            <Card className="w-full h-full flex items-center justify-center flex-col mb-[20px] p-[20px]">
              <ImgPlaceholder className="w-[100px]" src={picEmpty} />
              <span className="text-[14px] text-[#999]">暂无数据</span>
            </Card>
          )}
        </Loadding>
      </AnimatePresence>

      <Card className="p-[20px]">
        <Pagination total={total} size={size} index={index} onChange={change} />
      </Card>

      <Modal show={classState} cancel={() => setClassState(false)} header="" cancelText="好的" className="class-modal">
        <Comment lessonId={lessonId} />
      </Modal>

      <Modal show={pic ? true : false} cancel={() => setPic('')} header="" footer="" className="pic-modal">
        <ImgPlaceholder src={pic} />
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  .class-modal {
    width: 500px;
    padding: 0 0 20px 0;
    border-radius: 0;
  }
  .pic-modal {
    width: 500px;
    padding: 0;
    border-radius: 0;
  }
`
const Card = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  background-color: #fff;
  border-radius: 6px;
`
